import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.BudgetActionsMenu', {
    activateMenuName: 'Activate Budget',
    activateMenuTitle: 'Activate this budget to start checking Bills / POs against it',
    deactivateMenuName: 'Deactivate Budget',
    deactivateMenuTitle: 'Deactivate this budget to stop checking Bills / POs against it',
    showSettingsMenuName: 'Budget settings',
    showSettingsMenuTitle: 'Change the settings of the budget',
    reuploadMenuName: 'Reupload budget',
    downloadMenuName: 'Download budget as .CSV',
    removeMenuName: 'Remove',
    refreshMenuName: 'Refresh',
    refreshMenuTitle: 'Pull the latest version of this budget from Xero',
    confirmRemove: 'Do you really want to remove the budget?',
    successRemove: 'Budget removed',
    hasBeenActivated: 'Budget has been activated',
    hasBeenDeactivated: 'Budget has been deactivated',
});
